import React, { Component } from 'react';
import * as zenscroll from 'zenscroll';

import './LoadingBlock.css';

export default class LoadingBlock extends Component {
	constructor(props) {
		super(props);
	  }
	componentDidMount() {
		let anchor = document.getElementById("loading-block");
		if (this.props.purchase) zenscroll.center(anchor, 1000, 150);
	}

	render() {
		return (
			<div style={{width:'100%'}}>
			
				<div id="loading-block" className="loading-animation">
					<div className="loading-title">
						{ this.props.orders ? "Loading your orders..." : !this.props.purchase ? "Loading your results..." : "Finalizing your purchase..." }
					</div>
							<img alt="Loading" src="/images/loading.gif" />
					{
						this.props.isOrder ? <div style={{marginTop:'40px'}}>Please do not close this page until your order is finalized.</div>:<div></div>
					}
				</div>
			</div>
		);
	}
}




// WEBPACK FOOTER //
// ./src/components/common/LoadingBlock.js